import { FC, ReactElement } from "react";
import useDropdownContext from "./use-dropdown-context";
import { DropdownContextType } from "./dropdown-context";

export interface DropdownContextComponentProps {
  children(props: DropdownContextType): ReactElement;
}

const DropdownContextComponent: FC<DropdownContextComponentProps> = ({
  children,
}) => {
  const context = useDropdownContext();
  return children(context);
};

export default DropdownContextComponent;
